// Public-only Stimulus controllers
// These controllers are loaded on the public site, never in the admin panel
import { application } from "./application"

import aplauso_counter_controller from "./aplauso_counter_controller"
import close_article_controller from "./close_article_controller"
import noticia_gallery_controller from "./noticia_gallery_controller"
import noticia_like_controller from "./noticia_like_controller"
import noticia_parallax_controller from "./noticia_parallax_controller"
import noticias_carousel_controller from "./noticias_carousel_controller"
import news_enter_transition_controller from "./news_enter_transition_controller"
import news_exit_transition_controller from "./news_exit_transition_controller"
import video_play_icon_controller from "./video_play_icon_controller"
import dropdown_controller from "./dropdown_controller"
import youtube_carousel_controller from "./youtube_carousel_controller"
import calendario_carousel_controller from "./calendario_carousel_controller"
import partido_card_controller from "./partido_card_controller"
import scroll_top_controller from "./scroll_top_controller"
import anuncio_popup_controller from "./anuncio_popup_controller"

application.register("aplauso-counter", aplauso_counter_controller)
application.register("close-article", close_article_controller)
application.register("noticia-gallery", noticia_gallery_controller)
application.register("noticia-like", noticia_like_controller)
application.register("noticia-parallax", noticia_parallax_controller)
application.register("noticias-carousel", noticias_carousel_controller)
application.register("news-enter-transition", news_enter_transition_controller)
application.register("news-exit-transition", news_exit_transition_controller)
application.register("video-play-icon", video_play_icon_controller)
application.register("dropdown", dropdown_controller)
application.register("youtube-carousel", youtube_carousel_controller)
application.register("calendario-carousel", calendario_carousel_controller)
application.register("partido-card", partido_card_controller)
application.register("scroll-top", scroll_top_controller)
application.register("anuncio-popup", anuncio_popup_controller)
